import axios from 'utils/axios';

export interface TariffApplicationPayload {
    planId: string;
    planKey: string;
    accountUuid: string;
    companyName: string;
    taxId: string;
    phone: string;
    email: string;
    legalAddress: string;
    representativeName: string;
}

export interface TariffApplicationResult {
    stat?: boolean;
}

export const sendTariffApplication = async (
    data: TariffApplicationPayload,
): Promise<TariffApplicationResult | null> => {
    try {
        const response = await axios.post('/tariff/application', data);
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};
